import { Modal } from "react-bootstrap";
import axiosMain from "../axiosMain";
import Button from "react-bootstrap/Button";
import ToastNotification from "./Toast/ToastNotification";
import { useEffect } from "react";
import { useState } from "react";
import ResetPasswordWithEmail from "./ResetPasswordWithEmail";
import { BASE_URLS } from "../utils/baseUrls";
import RegisterSuccess from "./RegisterSuccess";

const OtpVerification = ({ otpshowModal, setotpshowModal, resotp, setresOtp, handleClose, apiResponse, showModalLogin, type, phoneno, succRegister, setSuccRegister, logInDetails }) => {
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [timeLeft, setTimeLeft] = useState(60);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [emailList, setEmailList] = useState([]);
    const [showmulEmailModal, setShowmulEmailModal] = useState(false);

    const [showSuccessModal, setshowSuccessModal] = useState(false);

    console.log(otpshowModal, "otpshowModal1")
    useEffect(() => {
        if (otpshowModal === true) {
            setTimeLeft(60); // Reset timeLeft to 60 when modal is shown
        }
    }, [otpshowModal]);

    // useEffect(() => {
    //     if (otpshowModal === true) {
    //         let timer;

    //         if (timeLeft > 0) {
    //             timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    //         } else {
    //             setIsButtonDisabled(false); // Enable button when timer reaches 0
    //         }

    //         return () => clearTimeout(timer); // Cleanup on component unmount
    //     }
    // }, [timeLeft, otpshowModal]);

    useEffect(() => {
        if (otpshowModal === true && timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft((prevTime) => prevTime - 1), 1000);

            return () => clearTimeout(timer); // Cleanup timer on component unmount or before next execution
        }

        if (timeLeft === 0) {
            setIsButtonDisabled(false); // Enable button when timer reaches 0
        }
    }, [timeLeft, otpshowModal]);




    // Handle OTP submission
    const otphandleSubmit = async (e) => {
        debugger;
        e.preventDefault();
        if (otp.includes("")) {
            ToastNotification.warning("Please fill OTP.");
        } else {
            const otpCode = otp.join("");
            if (parseInt(otpCode) === resotp) {
                await axiosMain.post(type === "signupotpvalid" ? BASE_URLS + "/Registration/UserMobileVerification"
                    : BASE_URLS + "/Registration/IsMobileValid", {
                    Email: null,
                    MobileNo: type === "signupotpvalid" ? null : phoneno,
                    UserId: apiResponse?.UserId,
                    UserDetailId: apiResponse?.UserDetailId,
                    DomainId: apiResponse?.DomainId,
                    // IPAddress: "115.246.16.140",
                    OTP: parseInt(otpCode),
                    // DomainURL: "https://beta.tendergpt.io",
                }
                ).then((res) => {
                    if (res?.data?.SuccessCode === 1) {
                        if (type === "signupotpvalid") {

                            handleClose(false);
                            if (succRegister) {
                                setshowSuccessModal(true);
                            }
                            else {
                                showModalLogin(true);
                            }
                        }

                        // resetformikform();
                        setOtp(["", "", "", "", "", ""])
                        setotpshowModal(false);
                        ToastNotification.warning(res?.data?.SuccessMessage);
                    }
                    else if (res?.data?.SuccessCode === 2) {
                        if (type === "signupotpvalid") {
                            // showModalLogin(true);
                            handleClose(false);
                            if (succRegister) {
                                setshowSuccessModal(true);
                            }
                            else {
                                showModalLogin(true);
                            }
                        }
                        else if (type === "forgotpassword") {
                            setEmailList(res?.data?.emailIds);
                            // setEmailList([
                            //     {
                            //         "userId": 1414409,
                            //         "userEmailId": "lohebij147@ckuer.com"
                            //     },   
                            //     // {
                            //     //     "userId": 1413233,
                            //     //     "userEmailId": "cawev11798@bagonew.com"
                            //     // },
                            //     // {
                            //     //     "userId": 1413410,
                            //     //     "userEmailId": "rilihab514@poverts.com"
                            //     // },
                            //     // {
                            //     //     "userId": 1414260,
                            //     //     "userEmailId": "mikel30518@bixolabs.com"
                            //     // }
                            // ]);
                            setShowmulEmailModal(true);
                        }
                        // resetformikform();
                        setOtp(["", "", "", "", "", ""])
                        setotpshowModal(false);
                        ToastNotification.success(res?.data?.SuccessMessage);
                    }
                    else {
                        ToastNotification.warning(res?.data?.SuccessMessage);
                    }
                })
                    .catch((exx) => { ToastNotification.error("Otp verification Error !") })
            }
        }
    };
    const otphandleChange = (value, index) => {
        if (!/^\d*$/.test(value)) return;
        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);

        // Move to the next input if not the last one
        if (value && index < otp.length - 1) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };
    // Handle Resend OTP
    const otphandleResend = () => {
        setTimeLeft(60);
        setIsButtonDisabled(true);
        setOtp(["", "", "", "", "", ""]);
        axiosMain.post(BASE_URLS + "/Registration/ResendOtp",
            {
                Email: null,
                MobileNo: phoneno,
                UserId: apiResponse?.UserId,
                UserDetailId: apiResponse?.UserDetailId,
                DomainId: apiResponse?.DomainId,
                // IPAddress: "115.246.16.140",
                OTP: 0,
                // DomainURL: "https://beta.tendergpt.io",
            }).then((res) => {
                if (res?.data?.OTP != null)
                    setresOtp(res?.data?.OTP);
            }).catch((exx) => { })

        document.getElementById("otp-0").focus();
    };

    return (<>
        {/* OTP MODAL */}
        {/* <Modal show={otpshowModal} onHide={() => setotpshowModal(false)} centered>
            <Modal.Header>
                <Button onClick={() => setotpshowModal(false)} className="modal-btn-close"><i className="fa fa-close"></i></Button>
            </Modal.Header>
            <Modal.Body style={{ background: "transperant" }}>
                <div className="otptopcontainer">
                    <h2>OTP Verification</h2>
                    <p>Enter the 6-digit code sent to your phone:</p>
                    <form onSubmit={otphandleSubmit}>
                        <div className="otpContainer">
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-${index}`}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => otphandleChange(e.target.value, index)}
                                    className="otpInput"
                                />
                            ))}
                        </div>
                        <p>Resend OTP in {timeLeft} seconds</p>
                        <button type="submit" className={`${!isButtonDisabled ? "submit-disable" : "submitButton"} `} disabled={isButtonDisabled !== true}>
                            Verify OTP
                        </button>
                    </form>
                    <button onClick={otphandleResend} className={`${isButtonDisabled ? "resend-button-disable" : "resendButton"} `} disabled={isButtonDisabled}>
                        Resend OTP
                    </button>
                </div>
            </Modal.Body>
        </Modal> */}
        <Modal size="lg" show={otpshowModal} onHide={() => setotpshowModal(false)} centered>
            <Modal.Header>
                <Button onClick={() => setotpshowModal(false)} className="modal-btn-close"><i className="fa fa-close"></i></Button>
            </Modal.Header>
            <Modal.Body style={{ background: "transperant" }}>

                <div className="otptopcontainer">
                    <div className="modal-bx-filed-set">
                        <fieldset>
                            <legend>OTP Verification</legend>


                            <form onSubmit={otphandleSubmit}>
                                <div className="form-container-otp"><p>Enter the 6-digit code sent to your phone:</p>
                                    <div className="otpContainer">
                                        {otp.map((digit, index) => (
                                            <input
                                                key={index}
                                                id={`otp-${index}`}
                                                type="text"
                                                maxLength="1"
                                                value={digit}
                                                onChange={(e) => otphandleChange(e.target.value, index)}
                                                className="otpInput"
                                            />
                                        ))}
                                    </div>{
                                        timeLeft === 0 ? <p className="otp-resend">OTP expired. Please try again.</p> : <p>Resend OTP in {timeLeft} seconds</p>
                                    }

                                    <div className="otp-buttons">    <button type="submit" className={`${!isButtonDisabled ? "submit-disable" : "submitButton"} `} disabled={isButtonDisabled !== true}>
                                        Verify OTP
                                    </button>
                                        <button onClick={otphandleResend} className={`${isButtonDisabled ? "resend-button-disable" : "resendButton"} `} disabled={isButtonDisabled}>
                                            Resend OTP
                                        </button></div>
                                </div>

                            </form>

                        </fieldset>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
        {/* Reset password with mul modal */}
        <ResetPasswordWithEmail emailList={emailList} showmulEmailModal={showmulEmailModal}
            setShowmulEmailModal={setShowmulEmailModal} apiResponse={apiResponse} phoneNo={phoneno} />

        <RegisterSuccess showSuccessModal={showSuccessModal} setShowSuccessModal={setshowSuccessModal} setSuccRegister={setSuccRegister} logInDetails={logInDetails} />
    </>
    )
}
export default OtpVerification;